import React from 'react';
import { getStatusByVersionState, StateIndicator } from '../../../_lib/components/StateIndicator';
import { DateFormat, DateFormats } from '../../../_lib/components/DateFormat';
import ILink from '../../../types/ILink';
import { VersionState, VersionStates } from '../../../types/api/VersionState';
import { StateItemWrapper } from './StateItemWrapper';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export type PageStateListItemProps = {
  active: boolean;
  link: ILink;
  timestamp?: string | null;
  versionState: VersionStates;
  importantChange: boolean;
};
/**
 * Handles rendering of the `CollapsibleOverlay` Items either as link or span
 */
export function PageStateListItem({
  timestamp = null,
  versionState,
  importantChange,
  ...props
}: PageStateListItemProps) {
  const { t } = useSonTranslation('PageState');

  return (
    <StateItemWrapper {...props}>
      {versionState === VersionState.published ? (
        <StateIndicator status={getStatusByVersionState(versionState)} />
      ) : null}
      <span className={versionState === VersionState.published ? undefined : 'page-state__list-item--draft'}>
        <span className="page-state__link-text">{t(`versionState.${versionState}`)}</span>
        {timestamp && (
          <DateFormat date={timestamp} format={DateFormats.DATE_TIME_SECONDS} className="page-state__list-item-date" />
        )}
        {importantChange ? <span className="page-state__link-text">{t(`importantChange`)}</span> : null}
      </span>
    </StateItemWrapper>
  );
}
